module.exports = __webpack_public_path__ + "static/media/IMG_2445.d32884a0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/IMG_2445.jpg
 ** module id = 404
 ** module chunks = 0
 **/